import * as React from 'react';
import { Route } from 'react-router';

import PageIndex from 'src/Views/ViewsIndex';
import styled from 'styled-components';

import { Helmet } from 'react-helmet'

import './App.css';

const Container = styled.div`
    flex: 1 1 auto;
    display: flex;
`;

const App = () => (
    <Container>
        <Helmet>
            <title>SAFE Form</title>
        </Helmet>
        <Route exact={true} path="/:token" component={PageIndex} />
        <Route exact={true} path="/" component={PageIndex} />
    </Container>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx